import { render, staticRenderFns } from "./MSA.vue?vue&type=template&id=53568fac&scoped=true"
import script from "./MSA.vue?vue&type=script&lang=js"
export * from "./MSA.vue?vue&type=script&lang=js"
import style0 from "./MSA.vue?vue&type=style&index=0&id=53568fac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53568fac",
  null
  
)

export default component.exports